import { createPost } from "blog/post"
import { NodeKind } from "blog/json_nodes"
import { createExternalLink, createReferenceLink } from "blog/components/link"

export const IncrementalProductAndEngineering = createPost({
  kind: NodeKind.POST,
  tags: [],
  title: "Incremental Product And Engineering",
  date: "2020-08-05T:18:45:00.0000Z",
  content: `
    <h1>Incremental Product And Engineering</h1>
    
    <p>
      product and engineering

    </p>
    <p>
      thats not how you should make a decision regarding adding, removing, or changing a feature. you should take an incremental approach modeled after bayesian inference
    </p>
    <p>
      when using bayesian inference to solve a problem we take our prior beliefs to be a forecast of an event occurring.
      we take this starting point and adjust this forecast as new information comes affirms or denies
      we design questions and experiments so that the answers and results can be used to adjust from our starting point to what is hopefully a better probabalistic view of reality
      we can then use this new probability in our model to forecast something in the future
    </p>
    <p>
      "your forecast" in context of product and engineering is about improving some combination of
      product market fit, market dominance, growth, diversification, profitability and a variety of other goals. 
      a similar process can be modelled in our product/engineering process by drawing intuitive analogs along two dimensions
      your priors are comprised of your product (current features, users, analytical data, analysis and proven theories about
      why the product works) and engineering (current architecture, feature support, bugs, hacks, and any other pertinent implementation details) 
      your product and engineering priors as defined above are your starting point with regard to the goals defined earlier.
      I'll refer to this simply as "your product" from here on. subsequent changes you make to your product are your new forecast
    </p>
    <p>
      in the world of bayesian inference new forecasts are made in response to new information
    </p>
    <p>
      in the world of SaaS product/engineering changes are made in response for myriad reasons
    </p>
    <p>
      when we make product changes we are making a new forecast based on new information.
      typically the information used to update does not have to be perfect, but it should contain some clear distinguishable signal.
    </p>
    <p>
      we are not using new information to make a new forecast, however we are making a new forecast.
      we should do our best to make sure that information acted upon is as good as it can be.
      where our information is not <i>good</i> (where the bar for <i>good</i> is very high) we are likely dealing with some level of uncertainty.
    </p>
    <p>
      to deal with that uncertainty we should endeavour to:
      <ol>
        <li>minize how far into the future we forecast</li>
        <li>take great care to improve our information</li>
      </ol>
    </p>
    <p>
      when it is time to make a new forecast you should aim to do it with the best data available at the time.
      gathering perfect data is usually unfeasible, and the old adage of "some better is better than no data" may do the job.
      however no rule of thumb is without its exceptions. it becomes important to distinguish when you are gathering the right data from when you are not.
    </p>
    <p>
      user testing in the context of software products and engineering is a perfect opportunity to err when it comes time to make a decision.
      the UX world leans on small sample size user testing sessions, with a commonly touted figure of 5 users per test (see NNG article).
      the goal is typically to uncover usability issues, "do i have a diamond or a lump of coal".
      even for the stated goal of uncovering usability issues with a particular design (which fits our definition of a forecast above), this number is inadequate.
      the origin of the 5-user figure is a NNG article in which they also note that subsequent tests should be undertaken per 'group' of users.
      the data gathered is "usability issues".
      this method can not be used to compare the potential value of competing ideas, that should be done through experimentation and iteration.
      the creation of a user test in the context of a standard product engineering team necessitates drawing users focus to specific UX flows; deliberately narrowing the scope of a users focus is a ripe opportunity for congruence bias to creep in and negatively impact the value of a test. 
    </p>
  `,
  relatedPosts: [],
  references: [
    createReferenceLink(
      "https://hackernoon.com/bayesian-product-management-getting-out-of-your-own-head-977314dbabf5",
      "Bayesian Product Management: Getting Out of Your Own Head",
      "Josh Ben-David",
      "https://twitter.com/joshbendavid",
    ),
    createReferenceLink(
      "https://www.linkedin.com/pulse/mindset-exceptional-product-manager-bayesian-thinking-gokmen-atak/",
      "The Mindset of Great Product Managers",
      "Gokmen Atak",
      "https://www.gokmenatak.com",
    ),
  ],
  ads: [],
})
